import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import Link from '@/links';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';
import {DivMargined, FeatureItem, Grid} from '@/content/features/shared';

const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));

const assetVersion = process.env.ASSET_VERSION || 'defaultVersion';

const AdditionalFeaturesSection = () => {
  const t = useTranslations('features.additionalFeatures');

  const ServiceAndSupportFeaturesArray = t.raw('serviceSupport.features') as FeatureItem[];
  const OnboardingAndImplementationFeaturesArray = t.raw(
    'onboardingImplementation.features'
  ) as FeatureItem[];
  const SecurityAndComplianceFeaturesArray = t.raw('securityCompliance.features') as FeatureItem[];

  return (
    <SectionPadding>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" middle="xs">
            <Col xs={12}>
              <H2>{t('title')}</H2>
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('serviceSupport.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {ServiceAndSupportFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--blue50)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('onboardingImplementation.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {OnboardingAndImplementationFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--blue50)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('securityCompliance.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {SecurityAndComplianceFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--blue50)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>

        <Row center="xs">
          <Col xs={12}>
            <Link
              href={`/static/downloads/Workable-features.pdf?${assetVersion}`}
              variant="secondary-no-gradient"
              target="_blank"
              title="Download Workable features pdf">
              {t('downloadLink')}
            </Link>
          </Col>
        </Row>
      </Container>
    </SectionPadding>
  );
};

export default AdditionalFeaturesSection;
